import React from "react";
import "./NumPad.css";
import { Icon } from "semantic-ui-react";
import * as Constants from "../../utils/Constants";
import NumPadItem from "./NumPadItem";

const { KeyPadKeyCode } = Constants;

const NumPad = ({ onClick, className }) => {
  const _onClick = (e) => {
    var command =
      e.target.getAttribute("data-command") ||
      e.target.parentElement.getAttribute("data-command");

    onClick(command);
  };

  const letterClassName = "letter";
  const numberClassName = "number";
  const optionalClassName = "optional";
  const letterAndNumberClassName = `${letterClassName} ${numberClassName}`;
  const letterAndOptionalClassName = `${letterClassName} ${optionalClassName}`;

  const ArrowLeftIcon = () => <Icon name="long arrow alternate left" />;

  return (
    <div className={"NumPad container " + className}>
      <ul className={"characters"}>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.ONE}
          onClick={_onClick}
        >
          1
        </NumPadItem>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.TWO}
          onClick={_onClick}
        >
          2
        </NumPadItem>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.THREE}
          onClick={_onClick}
        >
          3
        </NumPadItem>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.FOUR}
          onClick={_onClick}
        >
          4
        </NumPadItem>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.FIVE}
          onClick={_onClick}
        >
          5
        </NumPadItem>
        <NumPadItem
          className={`${letterAndOptionalClassName} reverse-middle`}
          dataCommand={KeyPadKeyCode.BACKSPACE}
          onClick={_onClick}
        >
          <ArrowLeftIcon />
        </NumPadItem>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.SIX}
          onClick={_onClick}
        >
          6
        </NumPadItem>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.SEVEN}
          onClick={_onClick}
        >
          7
        </NumPadItem>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.EIGHT}
          onClick={_onClick}
        >
          8
        </NumPadItem>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.NINE}
          onClick={_onClick}
        >
          9
        </NumPadItem>
        <NumPadItem
          className={letterAndNumberClassName}
          dataCommand={KeyPadKeyCode.ZERO}
          onClick={_onClick}
        >
          0
        </NumPadItem>
        <NumPadItem
          className={`${letterAndOptionalClassName} k`}
          dataCommand={KeyPadKeyCode.K}
          onClick={_onClick}
        >
          K
        </NumPadItem>
        <NumPadItem
          className={`${letterAndOptionalClassName} reverse`}
          dataCommand={KeyPadKeyCode.BACKSPACE}
          onClick={_onClick}
        >
          <ArrowLeftIcon />
        </NumPadItem>
        <NumPadItem
          className={`${letterAndOptionalClassName} enter`}
          dataCommand={KeyPadKeyCode.ENTER}
          onClick={_onClick}
        >
          Enter
        </NumPadItem>
      </ul>
    </div>
  );
};

export default NumPad;
